import React from "react";

const Initiated = () => {
  return (
    <svg
      aria-hidden="true"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.7414 3.07143C12.9081 3.10715 13.051 3.25002 13.0867 3.4167C13.1105 3.51195 13.5987 5.67879 11.6342 7.61943L10.2889 8.96478L10.146 11.5364C10.1341 11.6674 10.0745 11.7864 9.9793 11.8698L8.80063 12.858C8.71729 12.9294 8.61014 12.9651 8.50299 12.9651C8.37203 12.9651 8.26487 12.9294 8.16963 12.8342L6.96715 11.6317L4.51456 9.17909L3.31208 7.9766C3.1454 7.80992 3.13349 7.53609 3.28827 7.35751L4.27645 6.17884C4.35979 6.08359 4.47884 6.02406 4.60981 6.01216L7.18145 5.86929L8.5268 4.51203C8.55061 4.49417 8.57145 4.47334 8.59228 4.4525C8.61312 4.43167 8.63395 4.41083 8.65777 4.39297C9.94359 3.19049 11.3127 3 12.0271 3C12.4438 3 12.7057 3.05953 12.7414 3.07143ZM12.2293 3.94169C12.265 4.44173 12.1936 5.46563 11.4078 6.50143L9.66956 4.76319C10.5506 4.09646 11.4197 3.92978 12.0269 3.92978C12.0983 3.92978 12.1698 3.92978 12.2293 3.94169ZM8.98007 5.38257L10.7897 7.18034L7.30135 10.6568L5.50358 8.85905L8.98007 5.38257ZM8.53851 11.8924L9.24095 11.309L9.30048 9.9637L7.95513 11.309L8.53851 11.8924ZM4.62224 10.3688C4.44366 10.1902 4.14601 10.1902 3.96743 10.3688L2.13394 12.2023C1.95535 12.3809 1.95535 12.6785 2.13394 12.8571C2.22919 12.9524 2.34824 13 2.4673 13C2.58636 13 2.70542 12.9524 2.80066 12.869L4.63415 11.0356C4.80083 10.8451 4.80083 10.5474 4.62224 10.3688ZM5.13429 11.5359L4.52709 12.1431C4.34851 12.3217 4.34851 12.6193 4.52709 12.7979C4.62234 12.8932 4.7414 12.9289 4.86045 12.9289C4.97951 12.9289 5.09857 12.8813 5.19381 12.7979L5.80101 12.1907C5.97959 12.0121 5.97959 11.7145 5.80101 11.5359C5.61052 11.3573 5.31287 11.3573 5.13429 11.5359ZM6.19377 6.84747L4.84841 6.91891L4.26503 7.62135L4.84841 8.20473L6.19377 6.84747Z"
        fill="#033D8B"
      />
    </svg>
  );
};

export default Initiated;
